import { AutocompleteItem } from '@/shared/api/global-search'
import { Button } from '@workspace/ui/components/Button'

interface KeywordSuggestionsProps {
    suggestions?: AutocompleteItem[]
    onSelect: (keyword: string) => void
    mode?: 'suggestion' | 'recent'
    isHidden?: boolean
}

export function KeywordSuggestions({
    suggestions,
    onSelect,
    mode = 'recent',
    isHidden = false,
}: KeywordSuggestionsProps) {
    if (!suggestions?.length || isHidden) return null
    const title = mode === 'suggestion' ? 'Gợi ý từ khóa' : 'Từ khoá tìm kiếm gần đây'

    return (
        <div className="flex flex-col gap-x-2 gap-2 text-sm">
            <h3 className="text-sm font-semibold text-text-heading">{title}</h3>

            <div className="flex flex-wrap gap-x-2 gap-y-1 ">
                {suggestions.map((item, index) => (
                    <Button
                        key={`${item.text}-${index}`}
                        variant="ghost"
                        className="h-auto p-0 text-blue-500 hover:text-blue-700 hover:bg-transparent font-medium text-sm leading-5"
                        onPress={() => onSelect(item.queryPlusText)}
                    >
                        {item.text}
                    </Button>
                ))}
            </div>
        </div>
    )
}
